'use strict';

exports.__esModule = true;
exports.getUser = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = relativeTypesSaga;

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _webSso = require('@vezeeta/web-sso');

var _relativeTypes = require('../actions/relativeTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getRelativeTypes),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(relativeTypesSaga);

var getUser = exports.getUser = function getUser(state) {
  return state.user;
};

function getRelativeTypes(actions) {
  var apiObj, res;
  return _regenerator2.default.wrap(function getRelativeTypes$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          apiObj = new _webSso.AuthApi();
          _context.next = 3;
          return apiObj.get(_webUtils.Urls.getPatientRelativeTypes + '?languageId=' + (actions.language === 'en' ? 1 : 2));

        case 3:
          res = _context.sent;

          if (!_webUtils.STATUS.isSuccess(res.status)) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return (0, _effects.put)({ type: _relativeTypes.RELATIVE_TYPES.SUCCESS, relativeTypes: res.data });

        case 7:
          _context.next = 11;
          break;

        case 9:
          _context.next = 11;
          return (0, _effects.put)({ type: _relativeTypes.RELATIVE_TYPES.FAIL });

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function relativeTypesSaga() {
  return _regenerator2.default.wrap(function relativeTypesSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_relativeTypes.RELATIVE_TYPES.LOAD, getRelativeTypes);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}